(() => {
  const section = document.querySelector('.kitchen-deck');
  if (!section) return;
  const steps = [...section.querySelectorAll('.kitchen-deck-step')];
  const cards = steps.map(step => step.querySelector('.kitchen-deck-card'));
  cards.forEach(card => {
    const actions = [...card.querySelectorAll('.kitchen-action')];
    const photo = card.querySelector('.kitchen-deck-photo img');
    const caption = card.querySelector('figcaption');
    const photoLink = card.querySelector('.kitchen-photo-link');
    actions.forEach((button, index) => {
      button.addEventListener('click', () => {
        actions.forEach(item => {
          item.setAttribute('aria-pressed', String(item === button));
          item.nextElementSibling.hidden = item !== button;
        });
        photo.src = button.dataset.image;
        photo.alt = button.dataset.name;
        if (photoLink) {
          photoLink.href = button.dataset.href;
          photoLink.setAttribute("aria-label", "View " + button.dataset.name);
        }
        caption.textContent = button.dataset.name;
      });
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % actions.length;
        if (event.key === 'ArrowUp') next = (index + actions.length - 1) % actions.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = actions.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          actions[next].focus({preventScroll:true});
          actions[next].click();
        }
      });
      const preload = () => { const image = new Image(); image.src = button.dataset.image; };
      button.addEventListener('pointerenter', preload, {once:true});
      button.addEventListener('focus', preload, {once:true});
    });
  });
  // The same query as the normal-flow fallback in homepage-cards.css: there the cards are not sticky and stay flat.
  const calm = matchMedia('(prefers-reduced-motion: reduce), (max-height: 620px), (min-width: 601px) and (max-height: 640px)');
  const stack = section.querySelector('.kitchen-deck-stack');
  const root = document.documentElement;
  // A covered card dims under a black layer: opacity k on it looks the same as brightness(1 - k) on the opaque card.
  const shades = cards.map((card, index) => {
    if (index === cards.length - 1) return null;
    const shade = document.createElement('span');
    shade.className = 'kitchen-deck-shade';
    shade.setAttribute('aria-hidden', 'true');
    card.append(shade);
    return shade;
  });
  // Sticky geometry, measured once per layout change: where each step sits in the flow, its pin top and height,
  // and where the stack's content ends. Scroll frames then compute the overlap from scrollY with no layout reads.
  const flow = [], pin = [], height = [];
  let end = 0, measured = false, pending = 0, near = false;
  const covered = cards.map(() => NaN);
  const clamp = value => Math.min(1, Math.max(0, value));
  function measure() {
    measured = true;
    const style = getComputedStyle(stack);
    const gap = parseFloat(style.rowGap) || 0;
    const box = stack.getBoundingClientRect();
    let y = box.top + scrollY + (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.paddingTop) || 0);
    steps.forEach((step, index) => {
      flow[index] = y;
      height[index] = step.offsetHeight;
      pin[index] = parseFloat(getComputedStyle(step).top) || 0;
      y += height[index] + gap;
    });
    end = box.bottom + scrollY - (parseFloat(style.borderBottomWidth) || 0) - (parseFloat(style.paddingBottom) || 0); // the content box ends the sticky range
    covered.fill(NaN);
  }
  const topAt = (index, y) => Math.min(Math.max(flow[index] - y, pin[index]), end - y - height[index]);
  function paint() {
    pending = 0;
    if (!measured) measure();
    const still = calm.matches, y = scrollY;
    cards.forEach((card, index) => {
      if (index === cards.length - 1) {
        if (covered[index] !== 0) { card.style.removeProperty('transform'); covered[index] = 0; }
        return;
      }
      const value = still ? 0 : clamp((topAt(index, y) + height[index] - topAt(index + 1, y)) / height[index]);
      if (Math.abs(value - covered[index]) < 1e-5) return;
      covered[index] = value;
      if (still) { card.style.removeProperty('transform'); shades[index].style.removeProperty('opacity'); return; }
      card.style.transform = `translateY(${-8 * value}px) rotate(${-1.4 * value}deg) scale(${1 - .035 * value})`;
      shades[index].style.opacity = (index === 0 ? .13 : .065) * value;
    });
  }
  const schedule = () => { if (!pending) pending = requestAnimationFrame(paint); };
  const remeasure = () => { measured = false; schedule(); };
  // Scroll work only while the section is within a screen of the viewport; one last paint when it leaves.
  new IntersectionObserver(entries => {
    const now = entries[entries.length - 1].isIntersecting;
    if (now !== near) {
      near = now;
      if (near) addEventListener('scroll', schedule, {passive: true});
      else removeEventListener('scroll', schedule);
    }
    schedule();
  }, {rootMargin: '100% 0px'}).observe(section);
  addEventListener('resize', remeasure, {passive: true});
  calm.addEventListener('change', remeasure);
  new ResizeObserver(remeasure).observe(section);
  new ResizeObserver(remeasure).observe(root);
  // The announcement strip moves every pin top; it toggles classes on <html>.
  let strip = '';
  new MutationObserver(() => {
    const now = root.classList.contains('season-a-on') + ':' + root.classList.contains('season-a-open');
    if (now !== strip) { strip = now; remeasure(); }
  }).observe(root, {attributes: true, attributeFilter: ['class']});
  if (document.fonts) document.fonts.ready.then(remeasure);
  addEventListener('load', remeasure);
  document.addEventListener('alda:landed', remeasure);
  paint();
})();
